<template>
	<div class="footer">
		<el-row>
			<el-col :span="18" :offset="3">
				<div class="f_list">
					<ul>
						<li :class="{ 'f_online': type=='index' }" @click="goTab('index')">
							首页
						</li>
						<li :class="{ 'f_online': type=='We' }" @click="goTab('We')">
							关于我们
						</li>
						<li :class="{ 'f_online': type=='Develop' }" @click="goTab('Develop')">
							研发领域
						</li>
						<li :class="{ 'f_online': type=='Vision' }" @click="goTab('Vision')">
							公司愿景
						</li>
						<li :class="{ 'f_online': type=='Address' }" @click="goTab('Address')">
							联系我们
						</li>
					</ul>
					<div class="f_call">
						<el-tooltip placement="top">
						  <div slot="content">
							  <img src="../assets/logo.png" />
						  </div>
						  <img src="../assets/微信/icon.png" />
						</el-tooltip>
						
						<img src="../assets/qq/icon.png" />
						<img src="../assets/微博icon.png" />
					</div>
				</div>
			</el-col>
		</el-row>
		<div class="icp">
			<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">备案：浙ICP备20013086号</a>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		computed:{
			type(){
				let num = 'index';
				if (typeof(this.$route.query.map) == 'undefined') {
					num = 'index'
				}else{
					num = this.$route.query.map
				}
				return num;
			}
		},
		mounted() {
			console.log(this.$route.query.map)
		},
		methods: {
			goTab(data){
				this.$router.push({path:'/', query: { map: data }})
				console.log(this.$route.query.map)
			}
		},
	}
</script>

<style lang="scss" scoped="scoped">
	.footer {
		width: 100%;
		height: 154px;

		.f_list {
			// width: 1200px;
			height: 92px;
			margin: 0 auto;
			margin-top: 20px;

			ul {
				display: inline;

				li {
					width: 80px;
					height: 92px;
					text-align: center;
					line-height: 92px;
					float: left;
					font-size: 18px;
					margin-right: 43px;
					cursor: pointer;
				}

				.f_online {
					color: #1388F4;
				}

				li:hover {
					color: #1388F4;
				}
			}

			.f_call {
				float: right;
				margin-top: 15px;

				img {
					margin-left: 12px;
				}
			}
		}

		.icp {
			text-align: center;
			font-size: 18px;
		}
	}
</style>
